export default {
  Shipbob: {id: 1, name: 'paymentMethod.shipbob'},
  Prepaid: {id: 2, name: 'paymentMethod.prepaid'}
}
